import { jsx as _jsx } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { forwardRef, useEffect, useId, useRef } from 'react';
export { TabProvider } from '@ariakit/react';
export const AnimatedTabPanel = forwardRef(function TabPanel(props, ref) {
    const tab = Ariakit.useTabContext();
    const defaultId = useId();
    const id = props.id ?? defaultId;
    const tabId = Ariakit.useStoreState(tab, () => props.tabId ?? tab?.panels.item(id)?.tabId);
    const previousTabId = usePrevious(Ariakit.useStoreState(tab, 'selectedId'));
    const wasOpen = tabId && previousTabId === tabId;
    return (_jsx(Ariakit.TabPanel, { ref: ref, id: id, tabId: tabId, ...props, "data-was-open": wasOpen || undefined }));
});
function usePrevious(value) {
    const ref = useRef(undefined);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
//# sourceMappingURL=index.js.map